import _extends from "@swc/helpers/src/_extends.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { BiData } from '@wix/da-bi/pkg/events';
import { useFlag } from '@wix/da-react-context/pkg/flags/hooks/useFlag';
import GhostButton from '@wix/da-ds/pkg/Buttons/GhostButton';
import TextButton from '@wix/da-ds/pkg/Buttons/TextButton';
import HiddenIcon from '@wix/da-ds/pkg/Icons/Hidden';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import HiddenLayout from './HiddenLayout';
import Hidden from './Icons/Hidden';
import Button from '../../Button';
import hiddenStyles from './Hidden.scss';
const MatureBlockedOverlay = (_param)=>{
    var { deviation , deviation: { author  } , disableMatureFilter , overrideMatureFilter , pushUserSettingsModal  } = _param, props = _object_without_properties(_param, [
        "deviation",
        "deviation",
        "disableMatureFilter",
        "overrideMatureFilter",
        "pushUserSettingsModal"
    ]);
    const { t  } = useTranslation();
    const sfwbrowse = useFlag('sfwbrowse');
    if (sfwbrowse) {
        // todo: this is essentially the same as nsfg's 13+
        return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
            icon: /*#__PURE__*/ React.createElement(HiddenIcon, {
                size: IconSize.HUGE
            }),
            text: t('deviationview.blocked.mature.text.sfwbrowse'),
            button: /*#__PURE__*/ React.createElement(GhostButton, {
                variant: "main",
                size: "medium",
                onClick: ()=>overrideMatureFilter(deviation.deviationId),
                biData: BiData({
                    evid: 305,
                    typeid: deviation.typeId,
                    itemid: deviation.deviationId
                })
            }, t('deviationview.blocked.unhideDeviation.sfwbrowse')),
            secondaryButton: /*#__PURE__*/ React.createElement(TextButton, {
                className: hiddenStyles['secondary-button'],
                size: "medium",
                variant: "main",
                onClick: pushUserSettingsModal,
                biData: BiData({
                    evid: 306,
                    typeid: deviation.typeId,
                    itemid: deviation.deviationId
                })
            }, /*#__PURE__*/ React.createElement(Trans, {
                i18nKey: 'deviationview.blocked.openContentFilterModal'
            })),
            deviation: deviation
        }, props));
    }
    return /*#__PURE__*/ React.createElement(HiddenLayout, _extends({
        deviation: deviation,
        icon: /*#__PURE__*/ React.createElement(Hidden, null),
        title: t('deviationview.blocked.mature'),
        text: props.compact ? null : t('deviationview.blocked.mature.text'),
        button: /*#__PURE__*/ React.createElement(Button, {
            view: "b14",
            height: props.compact ? 'small' : 'medium',
            onClick: overrideMatureFilter
        }, t('deviationview.blocked.displayAnyway')),
        secondaryButton: author && /*#__PURE__*/ React.createElement("button", {
            className: hiddenStyles['secondary-button'],
            onClick: disableMatureFilter
        }, t('deviationview.blocked.turnOffMatureFilter'))
    }, props));
};
MatureBlockedOverlay.displayName = 'MatureBlockedOverlay';
export default MatureBlockedOverlay;
